import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import Ripple from "vuetify/lib/directives/ripple";

import fr from "vuetify/es5/locale/fr";

Vue.use(Vuetify, {
  directives: {
    Ripple
  }
});

export default new Vuetify({
  lang: {
    locales: { fr },
    current: "fr"
  },
  icons: {
    iconfont: "mdi"
  }
});
